export const name = 'local-storage';
